<div class="dialog-container">
  <div class="dialog-header">
    <mat-card-title mat-dialog-title class="d-flex align-items-center mb-0">
      <mat-icon class="mr-2">{{ data.icon || 'description' }}</mat-icon>
      <div class="title">{{ data.title }}</div>
    </mat-card-title>
    <mat-card-subtitle>{{ data.subtitle }}</mat-card-subtitle>
  </div>
  <mat-divider></mat-divider>

  <mat-dialog-content class="form-container">
    <div class="col-sm-12 px-0">
      <form [formGroup]="shareFormGroup">
        <!-- Subject Field -->
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{
            'shared.send-request-popup.subject' | translate
          }}</mat-label>
          <input
            matInput
            formControlName="subject"
            placeholder="{{
              'shared.send-request-popup.subject-placeholder' | translate
            }}"
          />
        </mat-form-field>

        <!-- Additional Email Field -->
        <mat-form-field
          appearance="fill"
          class="w-100 ref-fields-form-field"
        >
          <mat-label>
            {{ 'shared.send-request-popup.additional-emails' | translate }}
          </mat-label>
          <mat-chip-grid #emailsChipList>
            <mat-chip
              *ngFor="let email of addedEmails"
              [selectable]="false"
              (removed)="removeEmail(email)"
            >
              {{ email }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="{{
                'shared.send-request-popup.additional-emails-placeholder'
                  | translate
              }}"
              #emailInput
              appEmailSuggest
              (emailSelected)="addEmail($event); emailInput.value = ''"
              formControlName="additionalEmail"
              [matChipInputFor]="emailsChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="
                addEmail(emailInput.value); emailInput.value = ''
              "
            />
          </mat-chip-grid>
          <mat-error
            *ngIf="
              shareFormGroup.controls.additionalEmail.hasError('email') ||
              emailValidationError
            "
          >
            {{
              'shared.send-request-popup.additional-emails.pattern-error'
                | translate
            }}
          </mat-error>
        </mat-form-field>

        <!-- Remarks -->
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{
            'shared.send-request-popup.remarks' | translate
          }}</mat-label>
          <textarea
            data-testid="step-documents-description"
            type="text"
            matInput
            rows="3"
            formControlName="remarks"
          ></textarea>
        </mat-form-field>

        <!-- Contact Details -->
        <div
          class="contact-row d-flex align-items-center mb-2"
          *ngFor="let contactDetail of contactDetails; let i = index"
        >
          <div class="checkbox-wrapper mr-2">
            <mat-checkbox
              [checked]="contactDetail.isSelect"
              (change)="update($event.checked, i)"
            ></mat-checkbox>
          </div>
          <div class="flex-grow-1">
            <el-multi-field
              appearance="fill"
              class="w-100"
              title="{{
                contactDetail.details.type === 'EMAIL' ? 'Email' : 'SMS'
              }}"
              placeholder="{{
                contactDetail.details.type === 'EMAIL'
                  ? 'johndoe@example.com'
                  : '011234567'
              }}"
              [data]="contactDetail.details"
            ></el-multi-field>
          </div>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <button
      (click)="onClickCancel()"
      class="mr-2"
      [color]="'primary'"
      mat-button
    >
      {{ 'shared.remarks-popup.cancel' | translate }}
    </button>
    <button
      mat-raised-button
      [color]="'primary'"
      [disabled]="checkDisability()"
      (click)="onClickShare()"
    >
      {{ 'shared.remarks-popup.share' | translate }}
    </button>
  </mat-dialog-actions>
</div>
